exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RpudJ8bYcm6MiJ6EQinSA{max-width:375px;margin:0 auto;text-align:center}.RpudJ8bYcm6MiJ6EQinSA h3{margin-bottom:25px}.RpudJ8bYcm6MiJ6EQinSA ._2RcqPxni_AGO_erHZ8dx2y{max-width:240px;text-align:left;margin:0 auto}._2SoJY0TbkPDkXElBDg7pAf{max-width:400px;margin:0 auto}._2SoJY0TbkPDkXElBDg7pAf ._2RiYk6nNtsneHQ6D-8u9p9{margin-top:30px}._2SoJY0TbkPDkXElBDg7pAf ._KEO03CJpplQ_IVRGUqgz{color:#ff3940}\n", ""]);

// Exports
exports.locals = {
	"Step2a": "RpudJ8bYcm6MiJ6EQinSA",
	"formArea": "_2RcqPxni_AGO_erHZ8dx2y",
	"Step2b": "_2SoJY0TbkPDkXElBDg7pAf",
	"numberInput": "_2RiYk6nNtsneHQ6D-8u9p9",
	"error": "_KEO03CJpplQ_IVRGUqgz"
};